import { render, staticRenderFns } from "./EndOfSchoolYear.vue?vue&type=template&id=56953d52"
import script from "./EndOfSchoolYear.vue?vue&type=script&lang=ts"
export * from "./EndOfSchoolYear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports